import PropTypes from 'prop-types';
import React from 'react';

import { Icon } from 'sheets';
import localize from 'components/Localize/Localize';

import styles from './ShippingModal.css';
import translations from './translations';

const ShippingModal = (props) => {
  return (
    <section className={styles[`shipping-modal`]}>
      <div className={styles[`shipping-icon`]}>
        <Icon
          className={styles[`icon`]}
          name="delivery-truck"
        />
      </div>
      <h2 className={styles[`shipping-modal-heading`]}>{props.t.heading}</h2>
      <p
        className={styles[`shipping-modal-subheading`]}
        dangerouslySetInnerHTML={{__html: props.subheading}}
      />
    </section>
  );
};

ShippingModal.propTypes = {
  subheading: PropTypes.string.isRequired,
  t: PropTypes.shape({
    heading: PropTypes.string,
  }),
};

export default localize(ShippingModal, translations);
